import { Dispatch, SetStateAction } from 'react';
import { useMutation, useQueryClient } from 'react-query';

import { errorMessage } from '@features/applications';
import axiosInstance from '@server/axiosInstance';
import { updatedNewHireContactRoute } from '../api/constants';
import { newHireContactList } from '../constants';

type useUpdateNewHireContactProps = {
    setErrorText: Dispatch<SetStateAction<string>>;
};

export const useUpdateNewHireContact = ({
    setErrorText,
}: useUpdateNewHireContactProps) => {
    const client = useQueryClient();
    const { mutate: updateNewHireContact, isLoading: isUpdatingNewHireContact } =
        useMutation({
            mutationFn: (variables: {
                email?: string;
                name?: string;
                company_id?: number;
                company_name?: string;
                id?: number;
            }) =>
                axiosInstance
                    .post(updatedNewHireContactRoute, variables) 
                    .then((res) => res.data),
            onSuccess: (data) => {
                if (data.status === 200) {
                    client.invalidateQueries([newHireContactList]);
                    setErrorText('');
                } else {
                    setErrorText(data?.message || errorMessage);
                }
            },
            onError: (error: { message?: string }) => {
                setErrorText(error?.message || errorMessage);
            },
        });

    return {
        updateNewHireContact,
        isUpdatingNewHireContact,
    };
};
